import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { TimePicker } from 'antd';
import 'date-fns'
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
   MuiPickersUtilsProvider,
   KeyboardTimePicker
} from '@material-ui/pickers';
import { setCartPanel } from '../../actions/panels';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { createTheme, TextField } from '@material-ui/core';
import LoadingSpinner from '../common/LoadingSpinner';
import { ModalBackButton } from '../common/ModalBackButton';
import clock from '../../assets/images/clock-icon.svg';
import DeliveryCard from './common/DeliveryCard';
import DeliveryAddressModal from './common/DeliveryAddressModal';
import { cartInfoUpdate, loadCartInformation, getDeliveryCharge } from '../../actions/cart';
import { openCartDelivery, closeCartDelivery } from '../../actions/modals';
import { getFormattedPickupTime } from '../../utils/dateUtil';
import { PHONE_REGEX, EMAIL_REGEX } from '../../config/constants';


class OrderInformation extends React.Component {

    constructor(props) {
        super(props);

        this.showDeliveryAddressModal = this.showDeliveryAddressModal.bind(this);
        this.showPickupTimeModal = this.showPickupTimeModal.bind(this);
        this.onSelectPickupTime = this.onSelectPickupTime.bind(this);
        this.setDeliveryAddress = this.setDeliveryAddress.bind(this);
        this.setDeliveryAddressWindow = this.setDeliveryAddressWindow.bind(this);
        this.setSelectedDate = this.setSelectedDate.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.openTimePicker = this.openTimePicker.bind(this);
        this.closeTimePicker = this.closeTimePicker.bind(this);
        this.setPickerStatus = this.setPickerStatus.bind(this);

        this.state = {
            pickupTimeVisible: false,
            deliveryAddressVisible: false,
            deliveryAddressShowChoose: false,
            error: '',
            loading: false,
            selectedDate: null,
            open: false
        }
    }

   
    setSelectedDate(value) {
        let pickup_time = getFormattedPickupTime(value);
        this.setState(()=> ({
            selectedDate: pickup_time
        }))
    }

    handleDateChange(date) {
      this.onSelectPickupTime(date)
    }

    openTimePicker() {
        this.setState(() => ({
            open: true
        }))
    }

    closeTimePicker() {
        this.setState(() => ({
            open: false
        }))
    }

    setPickerStatus(status) {
        this.setState({
            open: status
        })
    }

    showPickupTimeModal() {
        this.setState(() => ({
            pickupTimeVisible: true
        }));
    }

    setDeliveryAddressWindow(value) {
        this.setState(() => ({
            deliveryAddressShowChoose: value
        }));
    }

    showDeliveryAddressModal() {
        let addressScope = false;
        if (this.props.logged_in) {
            if (this.props.loggedUser.addresses.length > 0) {
                addressScope = true;
            }
        }
        this.props.dispatch(openCartDelivery());
        this.setState(() => ({
            deliveryAddressShowChoose: addressScope
        }));
    }

    renderPickupTime() {

        if (this.props.cart.pickup_time != "") {
            const pickupDate = new Date(this.props.cart.pickup_time.replace(' ', 'T')+"-03:00");
            let hours = pickupDate.getHours(),
                minutes = pickupDate.getMinutes(),
                ampm = (hours >= 12) ? "pm": "am";
            if (minutes < 10) {
                minutes = "0"+minutes;
            }
            if (hours > 12) {
                hours -= 12;
            }
            return  pickup_time = hours+":"+minutes+" "+ampm;
        }
        else {
            return "ASAP";
        }
    }

    onSelectPickupTime(value) {
        
        let curTime = new Date();
        let closeTime = new Date(this.props.currentLocation.location.pickupCloseTime.replace(' ', 'T')+"-03:00");

        curTime.setMinutes(curTime.getMinutes() + 30);
        if (curTime < value && value < closeTime) {

            let pickup_time = getFormattedPickupTime(value);

            this.props.dispatch(cartInfoUpdate({ prop: 'pickup_time', value: pickup_time }));
            this.setState(() => ({ selectedDate: pickup_time }));
        }
        else {
            this.props.dispatch(cartInfoUpdate({ prop: 'pickup_time', value: "" }));
            alert("Please select a time at least 30 minutes in the future, and 30 minutes before closing.");
        }
    }
    
    setDeliveryAddress(address, instructions, lat, lng) {

        // update the address
        this.props.dispatch(cartInfoUpdate({ prop: 'delivery_address', value: address }));
        this.props.dispatch(cartInfoUpdate({ prop: 'delivery_lat', value: lat }));
        this.props.dispatch(cartInfoUpdate({ prop: 'delivery_lng', value: lng }));

        // update the instructions (if they exist)
        this.props.dispatch(cartInfoUpdate({ prop: 'delivery_instructions', value: instructions || '' }));
        this.props.dispatch(closeCartDelivery());
        this.setState(() => ({
            deliveryAddressShowChoose: false
        }));
    }

    render() {
        if ( this.props.cart.loading ) {
            return (
                <LoadingSpinner />
            )
        } else {
            return (
                <div  className="menu-item-window">
                    <div className="close-button">         
                        <ModalBackButton 
                            clickAction={() => this.props.dispatch(setCartPanel())}
                        />             
                    </div>
                    <div className="order-info-wrapper">
                        <h2 className="heading in-item">Your Order Information</h2>
                        <div className="fine-print _2 _3">
                            Please enter your contact information and any additional order details below.
                        </div>
                        {(this.state.error != "") && <p className="error-text">{this.state.error}</p>}
                        <div >
                            <input         
                            className="text-field name"
                            maxLength="256" 
                            placeholder="Name (required)"
                            value={this.props.cart.name}
                            onChange={(e) => this.props.dispatch(cartInfoUpdate({ prop: 'name', value: e.target.value }))}
                            />
                            <input
                            className="text-field phone"
                            type={'custom'}
                            options={{
                                mask: '(999) 999-9999',
                            }}
                            value={this.props.cart.phone}
                            placeholder="(555) 555-5555"
                            onChange={(e) => this.props.dispatch(cartInfoUpdate({ prop: 'phone', value: e.target.value }))}
                            />
                            <input
                                className="text-field email"
                                placeholder="test@email.com"
                                value={this.props.cart.email}
                                onChange={(e) => this.props.dispatch(cartInfoUpdate({ prop: 'email', value: e.target.value }))}
                            />
                        </div>
                    </div> 

                    <div className="cart-section">
                        <div className="order-information-pickup-delivery">
                            {(this.props.currentLocation.location.pickup_options == "BOTH") && (
                                <div>
                                    <div className="cart-pickup-options">
                                        <div className="option-button">
                                            <a  
                                                className={(this.props.cart.order_type == "pickup") ? 'selected' : ''}  
                                                onClick={() => {
                                                    this.props.dispatch(cartInfoUpdate({prop: 'order_type', value: 'pickup'}));
                                                }}>
                                                    Pickup
                                            </a>
                                        </div>
                                        <div className="option-button">
                                            <a
                                                className={(this.props.cart.order_type == "delivery") ? 'selected' : ''}  
                                                onClick={() => {

                                                    if (this.props.logged_in && this.props.cart.delivery_address == '') {
                                                        if (this.props.loggedUser.defaultAddress != null && this.props.loggedUser.defaultAddress != "") {
                                                            this.props.dispatch(cartInfoUpdate({ prop: 'delivery_address', value: this.props.loggedUser.defaultAddress }));
                                                        }

                                                        if (this.props.loggedUser.defaultAddressInstructions != null && this.props.loggedUser.defaultAddressInstructions != "") {
                                                            this.props.dispatch(cartInfoUpdate({ prop: 'delivery_instructions', value: this.props.loggedUser.defaultAddressInstructions }));
                                                        }   
                                                    }
                                                    this.props.dispatch(cartInfoUpdate({prop: 'order_type', value: 'delivery'}));
                                                }} 
                                            >
                                                Delivery
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            )}  
                            {this.props.cart.locationError != '' && (
                                <div className="delivery-error-window">
                                    <p>{this.props.cart.locationError}</p>
                                </div>
                            )}

                            {(this.props.currentLocation.location.preorder_enabled == 1) && (
                                <div>               
                                    <div className="disclaimer">
                                        {(this.props.cart.order_type == "pickup") && ('What time would you like to pick up your eats?')}
                                        {(this.props.cart.order_type == "delivery") && ('What time would you like your eats delivered?')}
                                    </div>
                                    <div className="pickup-button-wrapper">

                                    <MuiThemeProvider theme={cbeatsMuiTheme}>
                                         <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                   
                                        <KeyboardTimePicker 
                                            InputAdornmentProps={{ position: 'start'}}
                                            InputProps={{ disableUnderline: true}}
                                            fullWidth
                                            keyboardIcon={ <img src={clock} width="25px" height="25px" /> }
                                            margin="normal"
                                            placeholder="ASAP"
                                            id="time-picker"
                                            onClick={() => this.setPickerStatus(true)}
                                            onClose={() => this.setPickerStatus(false)}
                                            open={this.state.open}
                                            TextFieldComponent={(props) => (
                                                <TextField {...props} onClick={() => this.openTimePicker()} />
                                            )}
                                            onChangeCapture={open}
                                            value={this.state.selectedDate}
                                            onChange={this.handleDateChange}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                            
                                        />
                                    
                                        </MuiPickersUtilsProvider>
                                     </MuiThemeProvider>
                                    </div>
                                </div>
                            )}  
                            </div>
                            {(this.props.cart.order_type == "delivery") && (   
                                <div className="order-information-delivery-card-width">
                                    <a onClick={this.showDeliveryAddressModal}>
                                        <DeliveryCard 
                                            deliveryAddress={this.props.cart.delivery_address} 
                                            deliveryInstructions={this.props.cart.delivery_instructions}  
                                        />
                                    </a>
                                </div>
                            )}
                        <DeliveryAddressModal 
                            deliveryAddressShowChoose={this.state.deliveryAddressShowChoose}
                            setDeliveryAddress={this.setDeliveryAddress}
                            setDeliveryAddressWindow={this.setDeliveryAddressWindow}
                        />
                    
                    <div>
                        <a
                            onClick={() => {
                                if (this.props.cart.name === undefined || this.props.cart.name.trim() == "") {
                                    this.setState((prevState) => ({error: "Please enter your name before continuing."}));
                                }
                                else if (this.props.cart.phone === undefined || this.props.cart.phone == "") {
                                    this.setState((prevState) => ({error: "Please enter your phone number before continuing."}));
                                }
                                else if (!PHONE_REGEX.test(this.props.cart.phone)) {
                                    this.setState((prevState) => ({error: "Invalid phone number supplied. Phone number must be 10 digits eg. 9876543210."}));
                                }
                                else if (this.props.cart.email === undefined || this.props.cart.email == "") {
                                    this.setState((prevState) => ({error: "Please enter your email address before continuing."}));
                                }
                                else if (!EMAIL_REGEX.test(this.props.cart.email)) {
                                    this.setState((prevState) => ({error: "Invalid Email address supplied."}));
                                }
                                else if (this.props.cart.order_type != "pickup" && this.props.cart.order_type != "delivery") {
                                    this.setState((prevState) => ({error: "Please select pickup or delivery."}));
                                }
                                else if (this.props.cart.order_type == "delivery" && (this.props.cart.delivery_address === undefined || this.props.cart.delivery_address == "")) {
                                    this.setState((prevState) => ({error: "Please enter a delivery address before continuing."}));
                                }
                                else {
                                    this.props.dispatch(cartInfoUpdate({ prop: 'loading', value: true }));
                                    // if it's pickup, just go to the checkout page
                                    // if it's delivery, check the delivery address first before moving on
                                    if (this.props.cart.order_type == "delivery") {

                                        this.props.dispatch(getDeliveryCharge(this.props.loggedUser.uid, this.props.currentLocation, this.props.cart, this.props.navigation, this.props.token));
                                
                                    }
                                    else {
                                    
                                        this.props.dispatch(loadCartInformation(this.props.loggedUser.uid, this.props.currentLocation, this.props.cart, this.props.navigation, this.props.token, true));
                                    }
                                }
                            }}
                        >
                            <div className="view-order-information-window-bottom">
                                <p className="button-label">CHECKOUT</p>
                            </div>
                    
                        </a>
                    </div>
                    </div>
                </div>         
            );
        }
    }
}


const cbeatsMuiTheme =  createTheme({
    palette: {
        primary: {
            main: '#fe5b5d',
        },
        secondary: {
            main: '#ffffff'
        }
    }
})


const mapStateToProps = (state) => {

    return {
      logged_in: state.auth.logged_in,
      token: state.auth.token,
      loggedUser: state.auth.user,
      cart: state.cart,
      currentLocation: state.currentLocation.info
    };
  };

export default connect(mapStateToProps)(OrderInformation);
